<template>
    <!-- Попап с таблицей история платежей -->
    <vs-popup class="table_popup history_popup" :title="$t('payment_history')" :active.sync="historyPopup">

        <div class="flex items-center justify-between">
            <div class="mb-2 flex items-center" v-if="contract && contract.contract_number">
                {{$t('contract')}}: <vs-chip class="ml-2 mr-5" color="primary">№{{contract.contract_number}}</vs-chip>
                {{$t('agreement_date')}}: <vs-chip class="ml-2 mr-5" color="primary">{{contract.contract_date}}</vs-chip>
            </div>
            <!-- <vs-button @click="openPayStatus()" color="primary" size="small" type="filled">{{$t('payment_status')}}</vs-button> -->
        </div>

        <div id="data-list-list-view" class="data-list-container">
            <vs-table
                :noDataText="$t('no_data_text')"
                ref="table"
                class="contract_popup_table"
                :data="historyList"
            >
                <template slot="thead">
                    <vs-th>№</vs-th>
                    <vs-th>{{$t('payment_type')}}</vs-th>
                    <vs-th>{{$t('debt')}}</vs-th>
                    <vs-th>{{$t('payment_date')}}</vs-th>
                    <vs-th>{{$t('paid_up')}}</vs-th>
                    <vs-th>{{$t('debt_overpayment')}}</vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody>
                        <vs-tr
                            :data="tr"
                            :key="indextr"
                            v-for="(tr, indextr) in data"
                        >
                            <vs-td>
                                {{indextr+1}}
                            </vs-td>

                            <vs-td>
                                <vs-chip transparent color="primary">
                                    {{tr.payment_type.name}}
                                </vs-chip>
                            </vs-td>

                            <vs-td>
                                <span v-html="priceReplace(tr.payment_moment_debt)"></span>
                            </vs-td>

                            <vs-td>
                                {{date(tr.payment_date)}}
                            </vs-td>

                            <vs-td>
                                <span v-html="priceReplace(tr.payment_amount)"></span>
                            </vs-td>

                            <vs-td>
                                <span v-html="priceDebtOrOverpayment(tr.debt_or_overpayment)"></span>
                            </vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
        </div>

        <!-- handler для инфинити скролла -->
        <infinite-loading class="vx-col w-full" ref="infiniteHistory" v-bind:distance="400" @infinite="infiniteHandler">
            <!-- показываем свой лоадер -->
            <div slot="spinner"></div>
            <!-- Если данных больше нет показываем сообщение -->
            <div slot="no-more"></div>
            <div slot="no-results">
                <div class="con-vs-alert con-vs-alert-primary">
                    <div class="vs-alert">{{$t('no_data_text')}}</div>
                </div>
            </div>
        </infinite-loading>

        <div id="history_loader" class="vs-con-loading__container"></div>
    </vs-popup>
</template>

<script>
import { price } from '../config'

export default {
    data() {
        return {
            page: 1,
            infiniteStatus: true,
            loading: false,
        }
    },
    watch: {
        historyPopup(val) {
            // При открытии окна обнуляем данные таблицы
            if(val) {
                this.infiniteStatus = true
                this.page = 1
                this.$refs['infiniteHistory'].status = 0
            }
        }
    },
    methods: {
        async openPayStatus() {
            this.historyPopup = false
            try {
                this.$vs.loading({
                    scale: 0.6
                })
                await this.$store.dispatch('finance/getPayHistory', {contract_uid: this.contract.uid})
            } catch(e) {
                this.$vs.notify({
                    text: this.$t('error'),
                    color: 'danger',
                })
            } finally {
                this.$vs.loading.close()
                this.$store.commit('finance/SET_PAY_HISTORY_POPUP', true)
            }
        },
        date(date) {
            // Перезаписываем дату
            return this.$moment(date).format('LL')
        },
        priceReplace(sum, color = '') {
            // Перезаписываем цену
            return price(sum, color)
        },
        priceDebtOrOverpayment(sum) {
            // Проверяем есть ли минус в сумме, если нет красим в красный цвет(долг), если есть то в зеленый(переплата), если сумма == 0 оставляем как есть
            let summa = String(sum)
            if(summa.includes('-')) {
                return `<strong class="text-success">-${ new Intl.NumberFormat('ru-RU').format(summa.replace('-', '')) }</strong> ${this.$t('tenge')}`
            } else if(summa === '0') {
                return `<strong>${ new Intl.NumberFormat('ru-RU').format(summa) }</strong> ${this.$t('tenge')}`
            } else {
                return `<strong class="text-danger">${ new Intl.NumberFormat('ru-RU').format(summa) }</strong> ${this.$t('tenge')}`
            }
        },
        async infiniteHandler($state) {
            // Если количество полученных элементов больше или равно общего количества, останавливаем инфинити скроллинг
            if(this.historyList.length >= this.historyCount)
                this.infiniteStatus = false

            // Если инфинити скроллинг активный запрашиваем данные для указанной страницы
            if(this.infiniteStatus) {
                try {
                    this.$nextTick(() => {
                        this.$vs.loading({
                            background: 'transparent',
                            container: '#history_loader',
                            scale: 0.6
                        })
                    })

                    this.page = this.page+1
                    await this.$store.dispatch('finance/getHistoryList', {uid: this.contract.uid, page: this.page})

                    $state.loaded()
                } catch(e) {
                    this.$vs.notify({
                        text: this.$t('error'),
                        color: 'danger'
                    })
                } finally {
                    this.$vs.loading.close('#history_loader > .con-vs-loading')
                }
            }
        }
    },
    computed: {
        historyList() {
            return this.$store.state.finance.historyList
        },
        historyCount() {
            return this.$store.state.finance.historyCount
        },
        contract() {
            return this.$store.state.finance.contract
        },
        historyPopup: {
            get () {
                return this.$store.state.finance.historyPopup
            },
            set (val) {
                this.$store.commit('finance/CLEAR_HISTORY_LIST')
                this.$store.commit('finance/SET_HISTORY_POPUP', val)
            }
        }
    }
}
</script>

<style lang="scss">
.history_popup{
    .vs-popup{
        width: 1020px;
    }
}
</style>

<style scoped lang="scss">
#history_loader{
    position: relative;
    min-height: 50px;
    .con-vs-loading{
        position: absolute;
    }
}
</style>
